import { z } from 'zod';
import { timestampSchema } from './common';

export const STATUS_JOBS = [
  'billing-sweep',
  'shop-sync',
  'nightly-billing-check',
  'database-backup',
] as const;

export const backupRunSchema = z.object({
  id: z.uuid(),
  status: z.enum(['running', 'ok', 'failed']),
  startedAt: timestampSchema,
  finishedAt: timestampSchema.nullable(),
  sizeBytes: z.int().nullable(),
  tables: z.int().nullable(),
  sha256: z.string().nullable(),
  error: z.string().nullable(),
});

export const adminStatusSchema = z.object({
  checkedAt: timestampSchema,
  shops: z.array(
    z.object({
      id: z.uuid(),
      name: z.string(),
      active: z.boolean(),
      checkedAt: timestampSchema.nullable(),
      checkError: z.string().nullable(),
      lastWebhookAt: timestampSchema.nullable(),
    }),
  ),
  mollie: z.object({ lastMessageAt: timestampSchema.nullable() }),
  alerts: z.object({
    failedMessages: z.int().min(0),
    heldMessages: z.int().min(0),
    waitingMessages: z.int().min(0),
    failedFollowUps: z.int().min(0),
    failureRecipients: z.int().min(0),
    noticeRecipients: z.int().min(0),
  }),
  jobs: z.array(
    z.object({
      name: z.enum(STATUS_JOBS),
      lastCompletedAt: timestampSchema.nullable(),
      lastFailedAt: timestampSchema.nullable(),
      healthy: z.boolean(),
    }),
  ),
  backups: z.object({
    enabled: z.boolean(),
    lastSuccess: backupRunSchema.nullable(),
    recent: z.array(backupRunSchema),
  }),
});

export type StatusJob = (typeof STATUS_JOBS)[number];
export type BackupRun = z.infer<typeof backupRunSchema>;
export type AdminStatus = z.infer<typeof adminStatusSchema>;
